import { utilFunctionService } from "@/utils/utils.service"
export default function isLoggedin ({ next }){
    if (utilFunctionService.getLocalStorageService("user")) {
        
          return next('learning-modules')
        
      }
    return next()
   }
